/* global __LOG_LEVEL__ */

// Numeric levels for reference: debug=10, info=20, warn=30, error=40
const LEVEL = (typeof __LOG_LEVEL__ !== 'undefined') ? __LOG_LEVEL__ : 30;

function nowIso() {
  try { return new Date().toISOString(); } catch (_) { return ''; }
}

function emit(method, ...args) {
  try {
    const ts = nowIso();
    const c = (typeof console !== 'undefined') ? console : null;
    if (!c) return;

    const methodToCall = (c[method] || c.log);
    if (args.length > 0 && typeof args[0] === 'string') {
      const prefix = `[${ts}] ${args[0]}`;
      methodToCall.call(c, prefix, ...args.slice(1));
    } else {
      methodToCall.call(c, `[${ts}]`, ...args);
    }
  } catch (_) { /* swallow logging errors */ }
}

export const log = {
  debug(...args) { emit('debug', ...args); },
  log(...args)   { emit('log',   ...args); },
  info(...args)  { emit('info',  ...args); },
  warn(...args)  { emit('warn',  ...args); },
  error(...args) { emit('error', ...args); },
  getLevel() { return LEVEL; }
};

export default log;

if (typeof window !== 'undefined') {
  window.AppLog = log;
  if (typeof window.__LOG_LEVEL__ === 'undefined') window.__LOG_LEVEL__ = LEVEL;
  if (typeof window.__LOG_DEBUG__ === 'undefined') window.__LOG_DEBUG__ = LEVEL <= 10;
  if (typeof window.__LOG_LOG__ === 'undefined') window.__LOG_LOG__ = LEVEL <= 10;
  if (typeof window.__LOG_INFO__ === 'undefined') window.__LOG_INFO__ = LEVEL <= 20;
  if (typeof window.__LOG_WARN__ === 'undefined') window.__LOG_WARN__ = LEVEL <= 30;
  if (typeof window.__LOG_ERROR__ === 'undefined') window.__LOG_ERROR__ = LEVEL <= 40;
}